/*eslint-disable*/
let constants = () => {
    let env = "dev";
    switch (env) {
        case "dev":
            return {
                "BASE_URL": `${process.env.REACT_APP_BASE_URL}/`,
                "LCT_GATEWAY": `${process.env.REACT_APP_LCT_GATEWAY}/`
            }
            break;
        case "uat":
            return {
                "BASE_URL": "http://uat-lctgateway.elixia.tech/",
                "LCT_GATEWAY": `${process.env.REACT_APP_LCT_GATEWAY}/`
            }
            break;
        case "qa":
            return {
                "BASE_URL": "http://qa-lctgateway.elixia.tech/",
                "LCT_GATEWAY": `${process.env.REACT_APP_LCT_GATEWAY}/`
            }
            break;
        default:
            return {
                'BASE_URL': 'http://dev-lctgateway.elixia.tech/',
                "LCT_GATEWAY": `${process.env.REACT_APP_LCT_GATEWAY}/`
            }
    }
}

export default constants();